// extracted by mini-css-extract-plugin
module.exports = {"MainLogin":"login_MainLogin__2KxU7","loginInput":"login_loginInput__1Ta4H","imgContainer":"login_imgContainer__1lP6e"};